import { numberFormat } from '../format';

/** The newest item that has a value, for the label a screen reader reads out. */
export function latest<T>(items: T[], has: (item: T) => boolean): T | undefined {
    for (let i = items.length - 1; i >= 0; i--) if (has(items[i])) return items[i];
    return undefined;
}

/** Milliseconds as people read them: one decimal below 10 ms, whole above; `none` when there is no value. */
export function formatMs(ms: number | null | undefined, none: string, locale: string): string {
    if (ms === null || ms === undefined) return none;
    return `${numberFormat(locale, ms < 10 ? 1 : 0).format(ms)} ms`;
}
